import React, { useEffect, useState } from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { adminAPI } from '../../services/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { toast } from 'sonner';
import { formatDate } from '../../utils/helpers';

export const AdminAuditLogsPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminAPI.getAuditLogs(0, 200)
      .then(res => setLogs(res.data))
      .catch(() => toast.error('Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout>
      <div className="space-y-6" data-testid="admin-audit-logs-page">
        <div>
          <h1 className="text-4xl font-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>Audit Logs</h1>
          <p className="mt-2 text-muted-foreground">Complete admin activity trail</p>
        </div>

        <Card>
          <CardHeader><CardTitle>Activity Log ({logs.length})</CardTitle></CardHeader>
          <CardContent>
            {loading ? <p className="text-center py-8">Loading...</p> : logs.length === 0 ? (
              <p className="text-center py-8 text-muted-foreground">No audit logs yet</p>
            ) : (
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Date</TableHead>
                    <TableHead>Admin</TableHead>
                    <TableHead>Action</TableHead>
                    <TableHead>Target</TableHead>
                    <TableHead>Reason</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {logs.map((log) => (
                    <TableRow key={log.id}>
                      <TableCell className="text-xs">{formatDate(log.created_at)}</TableCell>
                      <TableCell>{log.admin_email}</TableCell>
                      <TableCell><Badge variant="outline" className="capitalize">{log.action.replace('_', ' ')}</Badge></TableCell>
                      <TableCell className="font-mono text-xs">{log.target_user_id?.substring(0, 12) || '-'}</TableCell>
                      <TableCell className="text-sm">{log.reason || '-'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
};
